import { render, staticRenderFns } from "./SidebarBrand.vue?vue&type=template&id=2d1dd7a7"
import script from "./SidebarBrand.vue?vue&type=script&lang=js"
export * from "./SidebarBrand.vue?vue&type=script&lang=js"
import style0 from "./SidebarBrand.vue?vue&type=style&index=0&id=2d1dd7a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports